module.exports = __webpack_public_path__ + "static/media/Developmenticon02@3x.743ec30e.png";